export default import.meta.ROLLDOWN_FILE_URL_d0vsaepC5HwMNT2$z9p2Ug